module.exports = __webpack_public_path__ + "img/o4.5beb467f.svg";